import { useStaticQuery, Link } from "gatsby"
import React from "react"
import Logo from "../assets/img/SEODevelopments_fullLogo.png"
import {FaPhoneAlt, FaUser} from "react-icons/fa"
// import BasketWidget from "./basket-widget"
// import SearchWidget from "./search-widget"

const Nav = () => {

const data = useStaticQuery(graphql`
    {
    strapiMainMenu {
      Menu {
        URL
        Label
        id
      } 
    }
  }
`)


return (
    <div>
        <div className={" navigationBar"}>
        <div data-uk-sticky="animation: uk-animation-slide-top; sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky; cls-inactive: uk-navbar-transparent; top:100">
        <nav className="nav-options uk-navbar-container uk-position-top uk-navbar-transparent" data-uk-navbar>
            <div className="uk-navbar-left" >
            <ul className="uk-navbar-nav">
                <li>
                <Link className="logoLight" to="/"><img src={Logo} alt="SEO Developments logo" width="200"/></Link>
                {/* <Link className="logoDark" to="/"><img src={LogoDark} alt="The insurers logo dark" width="200"/></Link> */}
                
                
                </li>
            </ul>
            </div>

            <div className="uk-navbar-right uk-visible@m">
                <ul className="uk-navbar-nav">

                {/*hardcoded until we reset the password to strapi */}
                <li>
                    <Link to={`/no-win-no-fee`} >
                    No win no fee
                    </Link>
                </li>

                
                    {data.strapiMainMenu.Menu.map((item, i) => {

                            return (
                            <li key={item.id} >

                                <Link to={`/${item.URL}`} >
                                {item.Label}
                                </Link>

                                {/* {(item.Submenu.length > 0)
                                ?<div className="uk-navbar-dropdown submenu-container" data-uk-dropdown="offset: -15">
                                    <ul className="uk-nav uk-navbar-dropdown-nav">
                                        {item.Submenu.map((subitem, i) => {
                                            return(
                                                <li key={subitem.id} className="subitem"><Link to={`/${item.URL + "/" + subitem.URL}`} >{subitem.Label}</Link></li>
                                            )
                                        })}

                                    </ul>
                                </div>
                                : ""

                                 } */}


                            </li>
                            )
                        
                        
                        })

                    }
                    
                    
                </ul>


                {(data.strapiMainMenu.CTA !== undefined)?
                <a className="nav-cta cta-primary-btn accent" href={"/"+data.strapiMainMenu.CTA.URL}>{data.strapiMainMenu.CTA.Label}</a>
                :""
                }

                <ul className="uk-navbar-nav">
                    <li><a href="tel:03301343283"><FaPhoneAlt style={{margin: "0 1rem"}}></FaPhoneAlt>0330 134 3283</a></li>
                    <li><a href="https://www.seodevelopments.co.uk/portal/Account/Login"><FaUser style={{margin: "0 1rem"}}></FaUser>Client Login</a></li>
                </ul>
                
            </div>

            {/* <div className="uk-navbar-right uk-visible@m">
                <ul className="uk-navbar-nav">
                    <li><a href="tel:08081962821"><FaPhoneAlt style={{margin: "0 1rem"}}></FaPhoneAlt>0808 196 2821</a></li>
                    <li><a href="https://www.seomarketing.co.uk/portal/Account/Login"><FaUser style={{margin: "0 1rem"}}></FaUser>Client Login</a></li>
                </ul>
                
            </div> */}

            


            <div className="uk-navbar-right uk-hidden@m">
                
                <a href="#offcanvas-usage" className="uk-navbar-toggle menuMobileBtn" data-uk-toggle="target: #offcanvas-menu">
                    <span className="uk-margin-small-right">Menu</span>
                    <span data-uk-navbar-toggle-icon>&nbsp;</span>
                </a>
            </div>

            <div id="offcanvas-menu" data-uk-offcanvas="overlay: true; flip: true; mode: reveal">
                <div className="uk-offcanvas-bar uk-flex uk-flex-column">

                    <button className="uk-offcanvas-close" type="button" data-uk-close aria-label="close button"></button>

                    

                    <ul className="uk-nav uk-nav-primary uk-nav-center uk-margin-auto-vertical uk-nav-parent-icon" data-uk-nav="multiple: true">
                    <li><Link to="/">Home</Link></li>
                        {data.strapiMainMenu.Menu.map((item, i) => {
                            return (

                                <li key={item.id} className="">
                                    <Link to={`/${item.URL}`}>
                                        {item.Label}
                                    </Link>
                                    {/* {(item.Submenu.length > 0)?
                                        <ul className="uk-nav-sub">
                                            {item.Submenu.map((subitem, i) => {
                                                return( 
                                                    <li key={subitem.id}><Link to={`/${item.URL + "/" + subitem.URL}`} >{subitem.Label}</Link></li>
                                                )
                                            })}
                                            
                                        </ul>
                                        :""
                                    } */}
                                    
                                </li>

                                
                                        
        
                            )
                        })}

                        <li><a href="tel:03301343283"><FaPhoneAlt style={{margin: "0 1rem 0 -2rem"}}></FaPhoneAlt>0330 134 3283</a></li>
                        <li><a href="https://www.seodevelopments.co.uk/portal/Account/Login"><FaUser style={{margin: "0 1rem 0 -2rem"}}></FaUser>Client Login</a></li>
                    </ul>
                </div>
            </div>


            


        </nav>
        </div>
        </div>


    </div>
)}

export default Nav